"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axis = void 0;
const Vector3_1 = require("./Vector3");
/**
 * Defines the 3 main axes
 * @public
 */
class Axis {
}
exports.Axis = Axis;
/** X axis */
Axis.X = new Vector3_1.Vector3(1.0, 0.0, 0.0);
/** Y axis */
Axis.Y = new Vector3_1.Vector3(0.0, 1.0, 0.0);
/** Z axis */
Axis.Z = new Vector3_1.Vector3(0.0, 0.0, 1.0);
//# sourceMappingURL=Axis.js.map